/**
 * 自己常用的代码块
 * @type {{resultShengLue: xlhuang.resultShengLue, GetQueryString: xlhuang.GetQueryString, binarySystem: xlhuang.binarySystem, analysisBinarySystem: xlhuang.analysisBinarySystem}}
 */

var xlhuang = {


	/**
	 * 将时间戳转化为xxxx-xx-xx 或 xxxx/xx/xx
	 * @param value 时间戳
	 * @param f   符号 '/' 或 '-'
	 * @returns {*}
	 */

		dateInit: function (value, f) {
			if (value != '' || value != undefined) {
				value = new Date(value);
				var year = value.getFullYear();
				var month = value.getMonth() + 1;
				var date = value.getDate();
				var hour = value.getHours();
				var minute = value.getMinutes();
				var second = value.getSeconds();
				return year + f + month + f + date;
			} else {
				return '--';
			}
		},


		/**
		 * 保留几位小数
		 * @param value 数字
		 * @param num 保留几位
		 * @returns {*}
		 */


		keepDecimal: function (value, num) {
			if (value != "" || value != undefined) {
				value = parseFloat(value);
				if (isNaN(value)) {
					return "--";
				} else {
					num = num ? parseInt(num) : 0;
					if (num <= 0) return Math.round(value);
					value = Math.round(value * Math.pow(10, num)) / Math.pow(10, num);
					return value;
				}
			} else {
				return '--'
			}
		},


		/**
		 * 带标签的文本转化为纯字符串
		 * @returns {*}
		 */
		formateHtml: function (value) {
			if (value != "" || value != undefined
			) {
				let str = $(value).html()
				if (str.length > 60) {
					str = str.slice(0, 60) + "..."
				}
				return str
			}
			else {
				return '无数据'
			}
		},

		/**
		 * js截取字符串，中英文都能用
		 * @param str：需要截取的字符串
		 * @param len: 需要截取的长度
		 */

		resultShengLue: function resultShengLue(str, len) {
			var str_length = 0;
			var str_len = 0;
			str_cut = new String();
			str_len = str.length;
			for (var i = 0; i < str_len; i++) {
				a = str.charAt(i);
				str_length++;
				if (escape(a).length > 4) {
					//中文字符的长度经编码之后大于4
					str_length++;
				}
				str_cut = str_cut.concat(a);
				if (str_length >= len) {
					str_cut = str_cut.concat("...");
					return str_cut;
				}
			}
			//如果给定字符串小于指定长度，则返回源字符串；
			if (str_length < len) {
				return str;
			}
		}
		,
		/**
		 * 获取url属性
		 * GetQueryString("id")// 传入参数名
		 */

		GetQueryString: function GetQueryString(name) {
			var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
			var r = window.location.search.substr(1).match(reg);
			if (r != null)return unescape(r[2]);
			return null;
		}
		,

		/**
		 * 二进制传递
		 * @param str
		 * @returns {string}
		 */
		binarySystem: function binarySystem(str) {
			var total2str = "";
			for (var i = 0; i < str.length; i++) {
				var num10 = str.charCodeAt(i);  ///< 以10进制的整数返回 某个字符 的unicode编码
				var str2 = num10.toString(2);   ///< 将10进制数字 转换成 2进制字符串
				if (total2str == "") {
					total2str = str2;
				} else {
					total2str = total2str + " " + str2;
				}
			}
			return total2str;
		}
		,

		/**
		 * 解析二进制
		 * @param str
		 * @returns {string}
		 */
		analysisBinarySystem: function analysisBinarySystem(str) {
			var goal = "";
			var arr = str.split(' ');
			for (var i = 0; i < arr.length; i++) {
				var str2 = arr[i];
				var num10 = parseInt(str2, 2); ///< 2进制字符串转换成 10进制的数字
				goal += String.fromCharCode(num10); ///< 将10进制的unicode编码, 转换成对应的unicode字符
			}
			return goal;
		}

	}
;

module.exports = xlhuang;



// WEBPACK FOOTER //
// ./src/plug/xlhuang.js